"use client";
import { StateCreator } from "zustand";
import { IAssesmentPlan } from "../components/testData/carePlanData";
import { Asset, Organization, UserRole } from "../dataAccess/appsync";
import { UserProfile } from "@/lib/dataAccess/appsync";

export type AdminState = {
  assetTypeFilter: string | null;
  setAssetTypeFilter: (type: string | null) => void;
  userRoleFilter: UserRole | undefined;
  setUserRoleFilter: (role: UserRole | undefined) => void;

  adminModalOpen: boolean;
  adminModalType: string;
  assetToArchive: { assetId: string; title: string } | null;
  pendingNavigation: string | null;
  setPendingNavigation: (url: string | null) => void;

  selectedCarePlanId: string | null;
  setSelectedCarePlanId: (careplanId: string | null) => void;
  isEditCareplan: boolean;
  setIsEditCareplan: (isEdit: boolean) => void;
  isCreateOrgCareplan: boolean;
  setIsCreateOrgCareplan: (isCreate: boolean) => void;
  // Assessments
  careplanAssessmentId: string;
  setCareplanAssessmentId: (id: string) => void;
  selectedAssessments: IAssesmentPlan[];
  setSelectedAssessments: (assessments: IAssesmentPlan[]) => void;
  selectedAsset: Asset | null;

  setAdminModalOpen: (open: boolean) => void;
  setAdminModalType: (type: string) => void;
  setAssetToArchive: (asset: { assetId: string; title: string } | null) => void;
  setSelectedAsset: (asset: Asset | null) => void;
  handleCloseAdminModal: () => void;

  orgProfileMode: "view" | "edit" | "create";
  selectedAdminOrg: Organization | null;
  setOrgProfileMode: (mode: "view" | "edit" | "create") => void;
  setSelectedAdminOrg: (org: Organization | null) => void;

  userProfileMode: "view" | "edit";
  setUserProfileMode: (mode: "view" | "edit") => void;

  selectedUserToRemove: UserProfile | null;
  setSelectedUserToRemove: (user: UserProfile | null) => void;

  assetLinkSearchQuery: string;
  setAssetLinkSearchQuery: (query: string) => void;
};

export const createAdminSlice: StateCreator<AdminState, [], [], AdminState> = (
  set,
) => ({
  assetTypeFilter: null,
  setAssetTypeFilter: (type) => set({ assetTypeFilter: type }),
  userRoleFilter: undefined,
  setUserRoleFilter: (role) => set({ userRoleFilter: role }),

  adminModalOpen: false,
  adminModalType: "",
  assetToArchive: null,
  selectedAsset: null,

  selectedCarePlanId: null,
  setSelectedCarePlanId: (careplanId) =>
    set({ selectedCarePlanId: careplanId }),
  isEditCareplan: false,
  setIsEditCareplan: (isEdit) => set({ isEditCareplan: isEdit }),
  isCreateOrgCareplan: false,
  setIsCreateOrgCareplan: (isCreate) => set({ isCreateOrgCareplan: isCreate }),
  // Assessments
  careplanAssessmentId: "",
  setCareplanAssessmentId: (id) => set({ careplanAssessmentId: id }),
  selectedAssessments: [],
  setSelectedAssessments: (assessments) =>
    set({ selectedAssessments: assessments }),

  pendingNavigation: null,
  setPendingNavigation: (url) => set({ pendingNavigation: url }),

  setAdminModalOpen: (open) => set({ adminModalOpen: open }),
  setAdminModalType: (type) => set({ adminModalType: type }),
  setAssetToArchive: (asset) => set({ assetToArchive: asset }),
  setSelectedAsset: (asset) => set({ selectedAsset: asset }),
  handleCloseAdminModal: () =>
    set({
      adminModalOpen: false,
      adminModalType: "",
      assetToArchive: null,
      selectedAsset: null,
      selectedUserToRemove: null,
      pendingNavigation: null,
    }),

  orgProfileMode: "view",
  selectedAdminOrg: null,
  setOrgProfileMode: (mode) => set({ orgProfileMode: mode }),
  setSelectedAdminOrg: (org) => set({ selectedAdminOrg: org }),

  userProfileMode: "view",
  setUserProfileMode: (mode) => set({ userProfileMode: mode }),

  selectedUserToRemove: null,
  setSelectedUserToRemove: (user) => set({ selectedUserToRemove: user }),

  assetLinkSearchQuery: "",
  setAssetLinkSearchQuery: (query) => set({ assetLinkSearchQuery: query }),
});
